import { ClipboardList, Upload } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function DocumentRequestsCard({ openRequests, canWrite, fileRef }) {
  if (openRequests.length === 0) return null;
  return (
    <Card className="border-amber-300 bg-amber-50/50" data-testid="document-requests-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold text-slate-800 flex items-center gap-2">
          <ClipboardList className="w-4 h-4 text-amber-600" aria-hidden="true" />
          Documenti richiesti ({openRequests.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="space-y-2">
          {openRequests.map((r) => (
            <li key={r.id} className="flex flex-wrap items-center gap-3 rounded-lg border border-amber-200 bg-white p-3"
              data-testid={`document-request-${r.id}`}>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-900">
                  {r.description || r.requested_document_type}
                </p>
                <p className="text-xs text-slate-500">
                  {r.reason && <span>{r.reason} · </span>}
                  {r.due_date && <span>Scadenza: {new Date(r.due_date).toLocaleDateString("it-IT")}</span>}
                </p>
              </div>
              {canWrite && (
                <button type="button" onClick={() => fileRef.current?.click()}
                  className="inline-flex items-center gap-1 text-xs font-semibold text-white bg-green-700 hover:bg-green-800 rounded px-3 py-1.5 transition-colors"
                  data-testid={`document-request-upload-${r.id}`}>
                  <Upload className="w-3.5 h-3.5" aria-hidden="true" /> Carica
                </button>
              )}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
